/* global videojs */

import '../styles/audio-tracks-menu.css';
import { changeAudio }  from '../handlers/audio-tracks-handlers';
import OverlayGridMenu  from "../components/overlay-grid-menu";

function createAudioThumbnailElement (src) {
  const el = document.createElement('img');
  el.src   = src;
  el.className = 'vjs-audio-thumbnail';
  return el;
}

class SwitchAudioButton extends videojs.getComponent('Button') {

  constructor (player, options) {
    super(player, options);

    this.controlText('Switch between audios');
    this.addClass('vjs-switch-audio-button vjs-menu-button');

    this.player_.on('canplay', () => this.updateMenuItems());

    /* click / tap */
    this.el().addEventListener('click', () => this.openAudioMenu());

    let lastTouch = 0;
    this.el().addEventListener('touchend', e => {
      const now = Date.now();
      if (now - lastTouch > 50) {
        lastTouch = now;
        this.openAudioMenu();
        e.preventDefault();
      }
    });
  }

  /* ---------- overlay ---------- */
  openAudioMenu () {
    this.updateMenuItems();

    /* ¿qué pista está activa ahora? */
    let currentLabel = null;

    if (window.isDashSource) {
      currentLabel = window.dashMediaPlayer
        ?.getCurrentTrackFor?.('audio')?.lang
        || window.dashMediaPlayer?.getCurrentTrackFor?.('audio')?.label;
    } else if (window.isWebRTC) {                              // WEBRTC-★
      currentLabel = localStorage.getItem('selectedAudioLabel');
    } else {
      const t = Array.from(this.player_.audioTracks()).find(tr => tr.enabled);
      currentLabel = t?.label || null;
    }

    if (currentLabel) {
      localStorage.setItem('selectedAudioLabel', currentLabel);
      this.setAudioSelection(currentLabel);
    }

    const selected = localStorage.getItem('selectedAudioLabel');

    const itemsForGrid = this.audioItems.map(item => ({
      label   : item.audioName,
      thumb   : item.el().querySelector('img')?.src,
      selected: item.audioName === selected,
      onSelect: () => {
        localStorage.setItem('selectedAudioLabel', item.audioName);
        this.setAudioSelection(item.audioName);
        changeAudio(item.audioName, this.audioItems);
      }
    }));

    OverlayGridMenu(this.player_, itemsForGrid, { maxTile: '15rem' });
  }

  /* ---------- refresca lista ---------- */
  updateMenuItems () {
    const dashReady = window.isDashSource &&
        window.dashMediaPlayer?.getTracksFor;

    let audioTracks;

    if (dashReady) {
      audioTracks = window.dashMediaPlayer.getTracksFor('audio') || [];
    } else if (window.isWebRTC) {                              // WEBRTC-★
      /* creamos pseudo-tracks con la info del backend */
      audioTracks = (window.audioNames || []).map(label => ({ label }));
    } else {
      audioTracks = this.player_.audioTracks();
    }

    this.audioItems = this.createItems(audioTracks);

    /* pre-selección */
    let currentLabel = null;
    if (dashReady) {
      currentLabel = window.dashMediaPlayer.getCurrentTrackFor?.('audio')
                      ?.lang || window.dashMediaPlayer.getCurrentTrackFor?.('audio')?.label;
    } else if (window.isWebRTC) {                              // WEBRTC-★
      currentLabel = localStorage.getItem('selectedAudioLabel') || window.audioNames?.[0];
    } else {
      currentLabel = Array.from(audioTracks).find(t => t.enabled)?.label || null;
    }

    if (!localStorage.getItem('selectedAudioLabel') && currentLabel)
      localStorage.setItem('selectedAudioLabel', currentLabel);

    this.setAudioSelection(localStorage.getItem('selectedAudioLabel'));

    /* mostrar / ocultar botón */
    if (this.audioItems.length <= 1) this.hide();
    else                             this.show();
  }

  /* ---------- resalta la pista elegida ---------- */
  setAudioSelection (label) {
    (this.audioItems || []).forEach(item => {
      const sel = item.audioName === label;
      item.el().classList.toggle('vjs-selected', sel);
      item.el().setAttribute('aria-checked', sel);
    });
  }

  /* ---------- construye MenuItem ---------- */
  createItems (audioTracks) {
    const MenuItem = videojs.getComponent('MenuItem');
    const items    = [];

    for (let i = 0; i < audioTracks.length; i++) {
      const track = audioTracks[i];

      /* nombre visible */
      let audioName;
      if (window.isDashSource && track.lang)      audioName = track.lang;
      else if (!window.isDashSource && track.label) audioName = track.label;
      else if (window.isWebRTC)                   audioName = window.audioNames?.[i] || `Audio ${i+1}`;  // WEBRTC-★
      else                                        audioName = `Audio ${i+1}`;

      /* thumbnail */
      let thumb = "https://dzsyhtfpcz9op.cloudfront.net/staticResources/audiowave.png";
      if (window.audioImages?.length > i) thumb = window.audioImages[i];

      const thumbEl = createAudioThumbnailElement(thumb);
      const item    = new MenuItem(this.player_, { label: '' });
      if (thumbEl) item.el().appendChild(thumbEl);
      item.el().appendChild(document.createTextNode(audioName));
      item.audioName = audioName;

      const select = () => {
        localStorage.setItem('selectedAudioLabel', audioName);
        this.setAudioSelection(audioName);
        changeAudio(audioName, items);
      };

      item.on('click', select);

      /* gestos táctiles */
      let scrolling = false;
      item.on('touchstart', e => { e.preventDefault(); scrolling = false; });
      item.on('touchmove',  () => scrolling = true);
      item.on('touchend',   () => { if (!scrolling) select(); });

      items.push(item);
    }
    return items;
  }
}

/* Oculta icono genérico hasta que haya 2+ audios */
const css = document.createElement('style');
css.innerHTML = '.vjs-audio-button{display:none!important}';
document.head.appendChild(css);

videojs.registerComponent('SwitchAudioButton', SwitchAudioButton);
export default SwitchAudioButton;